import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const AdjustIcon = ({ color = '#000', style = {}, size = 'sm', ...attr }) => {
  return (
    <svg {...iconSizes[size]} style={style} viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path d="M16 0V8M4 0V5M8 5H0M20 11H12M4 8L4 16M16 11V16" stroke={color} strokeWidth="2" />
    </svg>
  );
};

export default AdjustIcon;
